import { GetterTree } from 'vuex'
import { FoldersState, UISharedFolderModel } from './folders.model'

export enum GetterTypes {
  GET_COMPANY_FOLDERS = 'GET_COMPANY_FOLDERS'
}

interface Getters {
  [GetterTypes.GET_COMPANY_FOLDERS](state: FoldersState): (a: string) => Array<UISharedFolderModel>
}

export const getters: GetterTree<FoldersState, unknown> & Getters = {
  [GetterTypes.GET_COMPANY_FOLDERS](state): (a: string) => Array<UISharedFolderModel> {
    return (id: string): Array<UISharedFolderModel> => {
      return state.folders[id] || []
    }
  }
}
